import styled, { css } from 'styled-components';
import Measurements from '../../../theme/measurements';

const secondaryStyles = css`
  background-color: var(--color-brand-primary-alt);
`;

const noPaddingStyle = css`
  // This might be confusing. Look at the margin / padding in the main styles.
  margin: unset;
`;

const CardHeading = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: var(--color-bg-primary);
  padding: ${Measurements.CARD_PADDING};
  ${(props) => props.noPadding && noPaddingStyle};
  ${(props) => props.secondary && secondaryStyles};
`;

export default CardHeading;
